(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero-project"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sz-hero-video')) {
  customElements.define('sz-hero-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      this.generation = (this.generation || 0) + 1;
      this.intent = false;
      this.visible = false;
      this.hasFrame = false;
      this.loadedProfile = null;
      this.failed = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.connection = navigator.connection;
      this.pageLoaded = document.readyState === 'complete';
      const options = { signal: this.controller.signal };
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.show('poster');
      this.hero = this.closest('.hero');
      const headerElements = [document.querySelector('.m-header__sticky'), document.querySelector('#announcement-bar')].filter(Boolean);
      const updateHeaderSpace = () => {
        const height = headerElements.reduce((sum, element) => sum + element.getBoundingClientRect().height, 0);
        this.hero?.style.setProperty('--hero-header-space', height + 'px');
        if (!this.loadedProfile && this.visible && this.autoAllowed()) void this.start();
        else if (this.loadedProfile && this.loadedProfile !== this.sourceProfile()) {
          this.pause(true);
          if (this.visible && this.autoAllowed()) void this.start();
        }
      };
      updateHeaderSpace();
      if ('ResizeObserver' in window) {
        this.headerObserver = new ResizeObserver(updateHeaderSpace);
        headerElements.forEach(element => this.headerObserver.observe(element));
        if (this.hero) this.headerObserver.observe(this.hero);
      }
      window.addEventListener('load', () => {
        this.pageLoaded = true;
        if (this.visible && this.autoAllowed()) void this.start();
      }, options);
      this.video.addEventListener('playing', () => {
        if (!this.intent || !this.isConnected) { this.video.pause(); return; }
        this.hasFrame = true;
        this.show('playing');
      }, options);
      this.video.addEventListener('ended', () => {
        if (this.visible && this.autoAllowed()) {
          this.video.currentTime = 0;
          void this.start();
        }
      }, options);
      // Source errors do not bubble; capture them so an unavailable MP4 restores the poster.
      this.video.addEventListener('error', () => this.fail(), { ...options, capture: true });
      this.motion.addEventListener('change', () => this.policyChanged(), options);
      this.connection?.addEventListener?.('change', () => this.policyChanged(), options);
      this.mobile.addEventListener('change', () => {
        this.pause(true);
        if (this.visible && this.autoAllowed()) void this.start();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else if (this.visible && this.autoAllowed()) void this.start();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          if (!this.visible) this.pause();
          else if (this.autoAllowed()) void this.start();
        }, { threshold: 0.01 });
        this.observer.observe(this);
      }
      // Without visibility observation, retain the poster.
    }
    disconnectedCallback() {
      this.pause();
      this.controller?.abort();
      this.observer?.disconnect();
      this.headerObserver?.disconnect();
      this.controller = null;
    }
    autoAllowed() {
      return !this.motion.matches && !this.connection?.saveData && !this.failed && !document.hidden;
    }
    policyChanged() {
      this.pause(true);
      if (this.visible && this.autoAllowed()) void this.start();
    }
    sourceProfile() {
      const profile = this.mobile.matches ? 'mobile' : 'desktop';
      const template = this.querySelector('[data-video-profile="' + profile + '"]');
      const bounds = this.hero?.getBoundingClientRect();
      const ratio = bounds?.height > 0 ? bounds.width / bounds.height : 0;
      const cropFits = profile === 'mobile' ? ratio > 0 && ratio <= 750 / 1030 + 0.01 : ratio >= 40 / 17 - 0.01;
      return profile + (template?.dataset?.src && cropFits ? '-optimized' : '-standard');
    }
    attachSource() {
      const profile = this.mobile.matches ? 'mobile' : 'desktop';
      const sourceProfile = this.sourceProfile();
      if (this.loadedProfile === sourceProfile) return true;
      const template = this.querySelector('[data-video-profile="' + profile + '"]');
      const available = Array.from(template?.content.querySelectorAll('source') || [])
        .filter(source => source.dataset.src && source.type === 'video/mp4')
        .sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
      const maximumWidth = profile === 'mobile' ? 1280 : 1920;
      const eligible = available.filter(source => Number(source.dataset.width) <= maximumWidth);
      const chosen = sourceProfile.endsWith('-optimized') && template?.dataset?.src
        ? { dataset: { src: template.dataset.src }, type: 'video/mp4' }
        : eligible.at(-1) || available[0];
      if (!chosen) return false;
      const source = document.createElement('source');
      source.src = chosen.dataset.src;
      source.type = chosen.type;
      this.video.replaceChildren(source);
      this.loadedProfile = sourceProfile;
      this.video.load();
      return true;
    }
    waitForInitialBuffer(generation) {
      this.cancelBuffer?.();
      if (this.video.currentTime > 0) return Promise.resolve(true);
      return new Promise(resolve => {
        let timer;
        const events = ['progress', 'loadeddata', 'canplay'];
        const finish = allowed => {
          clearTimeout(timer);
          events.forEach(event => this.video.removeEventListener(event, check));
          if (this.cancelBuffer === cancel) this.cancelBuffer = null;
          resolve(allowed);
        };
        const cancel = () => finish(false);
        const valid = () => this.isConnected && this.visible && this.intent &&
          generation === this.generation && this.autoAllowed();
        const check = () => {
          if (!valid()) { finish(false); return; }
          const position = this.video.currentTime;
          const required = Math.min(3, Number.isFinite(this.video.duration)
            ? Math.max(0, this.video.duration - position) : 3);
          for (let i = 0; i < this.video.buffered.length; i++) {
            if (this.video.buffered.start(i) <= position + 0.05 &&
                this.video.buffered.end(i) - position >= required) {
              finish(true); return;
            }
          }
        };
        this.cancelBuffer = cancel;
        events.forEach(event => this.video.addEventListener(event, check));
        // Keep the poster while acquiring runway. A stalled download must not
        // leave an unbounded wait or a stale play after visibility/source changes.
        timer = setTimeout(() => finish(valid() && this.video.readyState >= 2), 6500);
        check();
      });
    }
    recoverWhenPlayable(generation) {
      this.cancelBuffer?.();
      const events = ['progress', 'loadeddata', 'canplay'];
      const cleanup = () => {
        events.forEach(event => this.video.removeEventListener(event, recover));
        if (this.cancelBuffer === cleanup) this.cancelBuffer = null;
      };
      const recover = () => {
        if (!this.isConnected || !this.visible || !this.intent ||
            generation !== this.generation || !this.autoAllowed()) { cleanup(); return; }
        if (this.video.readyState < 2) return;
        cleanup();
        void this.start();
      };
      this.cancelBuffer = cleanup;
      events.forEach(event => this.video.addEventListener(event, recover));
      recover();
    }
    async start() {
      if (!this.isConnected || !this.visible || !this.pageLoaded || !this.autoAllowed()) return;
      if (!this.hero?.getBoundingClientRect().height) return;
      this.video.preload = 'auto';
      if (!this.attachSource()) { this.fail(); return; }
      const generation = ++this.generation;
      this.intent = true;
      this.show('loading');
      try {
        const buffered = await this.waitForInitialBuffer(generation);
        if (!this.isConnected || generation !== this.generation || !this.intent) return;
        if (!buffered) {
          this.show(this.hasFrame ? 'paused' : 'poster');
          this.recoverWhenPlayable(generation);
          return;
        }
        await this.video.play();
        if (!this.isConnected || generation !== this.generation || !this.intent) return;
        if (!this.video.paused && this.video.readyState >= 2) {
          this.hasFrame = true;
          this.show('playing');
        }
      } catch (error) {
        if (generation !== this.generation || !this.isConnected) return;
        this.fail();
      }
    }
    pause(unload = false) {
      this.cancelBuffer?.();
      this.generation = (this.generation || 0) + 1;
      this.intent = false;
      this.video?.pause();
      if (unload && this.video) {
        this.video.replaceChildren();
        this.video.removeAttribute('src');
        this.video.load();
        this.loadedProfile = null;
        this.hasFrame = false;
      }
      if (this.video) this.show(this.hasFrame ? 'paused' : 'poster');
    }
    fail() {
      this.failed = true;
      this.pause(true);
      this.dataset.videoState = 'fallback';
    }
    show(state) {
      this.dataset.videoState = state;

    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
